import { type CalenderAppointmentsSearchFilters } from "@/features/calendar/calendarFilter/appointmentFilterReducer";
import { type OpenModalProps } from "@/features/calendar/openCalendarModal";
import { t } from "@repo/translation";

import { CategoryRow } from "./CategoryRow";
import { CoWorkers } from "./CoWorkers";
import { type CoWorkerCalendar } from "./types";

export const UnassignedAppointments = ({
  startHour,
  totalHours,
  openModal,
  unassigned,
  filters,
  title,
}: {
  startHour: number;
  totalHours: number;
  unassigned?: CoWorkerCalendar[];
  filters: CalenderAppointmentsSearchFilters;
  openModal: (props: OpenModalProps) => void;
  title?: string;
}) => {
  if (!unassigned) {
    return null;
  }

  return (
    <CategoryRow title={title ?? t("label.unassigned")}>
      <CoWorkers
        startHour={startHour}
        totalHours={totalHours}
        coWorkers={unassigned}
        openModal={openModal}
        filters={filters}
      />
    </CategoryRow>
  );
};
